<template>
    <VueDaumPostcode
        @complete="onComplete"
        style="
            display: block;
            position: absolute;
            width: calc(100%);
            height: calc(100%);
            padding: 0.0rem;
            background-color: #ececec;
        "
    />
</template>

<script setup>
import { onBeforeMount, onMounted, onUpdated, onUnmounted } from "vue";
import { faLog } from "../common/faCommon.js";
import { VueDaumPostcode } from "vue-daum-postcode";

const props = defineProps({
    deviceOs: {
        type: String,
        required: true,
    },
});

const onComplete = (result) => {
    faLog(2, "[SearchAddressView] [onComplete] result", result);
    const srvLocObject = {
        zipCode: result.zonecode,
        sido: result.sido,
        sigungu: result.sigungu,
        sidoSigungu: result.sido + " " + result.sigungu,
        address: (result.roadAddress.replace((result.sigungu.length > 0 ? (result.sido + " " + result.sigungu) : (result.sido)), "").trim()),
        // buildingType: ((result.apartment === "Y" || result.apartment === "y") ? BuildingTypes.apartment.value : BuildingTypes.etc.value),
        buildingName: result.buildingName,
    };

    faLog(2, "[SearchAddressView] [onComplete] srvLocObject", srvLocObject);

    const _deviceOs = props.deviceOs.toString().toLocaleLowerCase();
    faLog(0, "[SearchAddressView] [onComplete] _deviceOs : " + _deviceOs);

    if (_deviceOs === "ios") {
        faLog(0, "[SearchAddressView] [onComplete] iOS");
        try {
            window.webkit.messageHandlers.onAddressSelected.postMessage(JSON.stringify(srvLocObject))
        } catch (err) {
            faLog(2, "[SearchAddressView] [onComplete] err", err);
        }

    } else if (_deviceOs === "android") {
        faLog(0, "[SearchAddressView] [onComplete] Android");
        try {
            window.Android.onAddressSelected(JSON.stringify(srvLocObject));
        } catch (err) {
            faLog(2, "[SearchAddressView] [onComplete] err", err);
        }
    }
};

/**
 * VUE.js Methods...
 */
onBeforeMount(() => {
    faLog(0, "[SearchAddressView] [onBeforeMount]");
});

onMounted(() => {
    faLog(2, "[SearchAddressView] [onMounted] props", props);
});

onUpdated(() => {
    faLog(0, "[SearchAddressView] [onUpdated]");
});

onUnmounted(() => {
    faLog(0, "[SearchAddressView] [onUnmounted]");
});
</script>